import { createContext } from 'react';

export type UpdatePlaidCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  UpdateError: string;
};

const UpdatePlaid = createContext<UpdatePlaidCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  UpdateError: '',
});

export default UpdatePlaid;
